import { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import LocationIcon from 'assets/discovery/Location-Icon.png';

import MultiSelect from 'components/PlannerTheme/Elements/MultiSelect';
import { getPlannerCountries } from 'api_handlers/discovery';
import { getPlannerUniqueES } from 'api_handlers/es';
import { BC_COUNTRIES } from 'constants/bcCountries';

function InfluencerCountry({ influencerCountries, hideAdvanceFilters, classes, bcRosterOnly = 'no' }) {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    if (bcRosterOnly === 'yes') {
      getPlannerUniqueES()
        .then((data) => {
          const codes = data?.audience_country_distribution_max || [];
          const options = codes
            .map((code) => ({ label: BC_COUNTRIES[code] || code, value: code }))
            .filter((opt) => opt.label)
            .sort((a, b) => a.label.localeCompare(b.label));
          setCountries(options);
        })
        .catch(() => setCountries([]));
    } else {
      getPlannerCountries().then((response) => {
        setCountries(
          (response.data || [])
            .filter((loc) => loc)
            .map((location) => ({ label: location, value: location }))
        );
      });
    }
  }, [bcRosterOnly]);
  return (
    <>
      <div
        style={{
          display: 'flex',
          marginBottom: 10,
          justifyContent: 'center',
        }}
      >
        <img alt="" src={LocationIcon} width={22} style={{ marginRight: 7 }} />
        <Typography className={classes.advanceHeading}>Country</Typography>
      </div>
      <div style={{ marginTop: 10 }}>
        <MultiSelect
          label={'Select Country'}
          options={countries}
          value={influencerCountries || []}
          onChange={(event, selectedValues) => {
            hideAdvanceFilters('influencerCountries', selectedValues);
          }}
        />
      </div>
    </>
  );
}

const styles = {
  advanceHeading: {
    fontFamily: 'Nunito Sans',
    fontWeight: 400,
    fontSize: 14,
  },
};

export default withStyles(styles)(InfluencerCountry);
